import { toMoney } from '@/general/src/other/money.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { RichText } from '@/webapp/src/components/other/RichText/index.js'
import { useAppContext } from '@/webapp/src/lib/ctx.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { Segment } from '@/webapp/src/lib/uninty.components.js'
import { Link } from 'react-router-dom'

export const PlansPage = withPageWrapper({
  title: 'Тарифы',
  Layout: GeneralLayout,
})(() => {
  const ctx = useAppContext()
  const free = ctx.appConfig.agentSubscriptionPlanMap.free
  const basic = ctx.appConfig.agentSubscriptionPlanMap.basic
  return (
    <Segment title="💰 Тарифы" size="m">
      <RichText>
        <p>
          <strong>🆓 «{free.label}»</strong>
          <br />
          👀 Подходит для ознакомления с программой
          <br />
          Каждый месяц доступно:
          <br />
          {free.temporaryScenarioTokensCountPerPeriod} токенов на сценарии
          <br />
          {free.temporaryRecognitionTokensCountPerPeriod} токенов на распознавание
        </p>
        <p>
          <strong>
            💼 «{basic.label}» — {toMoney({ amount: basic.pricePerPeriod })} в месяц
          </strong>
          <br />✅ Подходит для агентов с большим потоком клиентов
          <br />
          Каждый месяц доступно:
          <br />
          {basic.temporaryScenarioTokensCountPerPeriod} токенов на сценарии
          <br />
          {basic.temporaryRecognitionTokensCountPerPeriod} токенов на распознавание
        </p>
        <hr />
        <h2>📈 О токенах</h2>
        <p>
          Если вам не хватило токенов вашего тарифного плана, вы можете докупить их в любой момент по 1 ₽ за токен, если
          у вас подключен платный тарифный план
          <br />
          Токены выданные в рамках тарифа сгорают и обновляются ежемесячно
          <br />
          Докупленные токены не сгорают никогда, до тех пор, пока не будут использованы
          <br />
          Стоимость запуска сценария в одной страховой: 2 токена
          <br />
          Стоимость распознания всех страниц одного документа: 10 токенов
        </p>
        <hr />
        <h2 id="🔑-управление-подпиской">
          <strong>🔑 Управление подпиской</strong>
        </h2>
        <p>В интерфейсе программы СтрахоБот вы можете: </p>
        <p>✅ Изменить тарифный план</p>
        <p>✅ Включать или отключать автопродление подписки </p>
        <p>✅ Купить несгораемые токены для сценариев или распознаваний </p>
        <p>✅ Привязать или сменить карту оплаты </p>
        <p>✅ Смотреть историю ваших транзакций</p>
        <hr />
        <h2>🎯 Вопросы?</h2>
        <p>
          <Link to="https://t.me/+7yyTulkX8HBkZjEy" target="_blank">
            Напишите нам в поддержку
          </Link>{' '}
          — поможем выбрать тариф и рассчитаем, сколько токенов вам нужно.
        </p>
      </RichText>
    </Segment>
  )
})
